import styled from 'styled-components';

export const PrescriptionCodeContainer = styled.div`
  text-align: center;
  border-radius: 8px;
  background-color: #d9fbf9;
  width: 152px;
  padding: 4px 0;
`;

export const IconContainer = styled.span`
  margin-right: 8px;
  width: 32px;
  height: 32px;
  background-color: #f8f9fa;
  display: flex;
  justify-content: center;
  border-radius: 50%;
  align-items: center;

  img {
    height: 22px;
    width: 16px;
  }
`;

export const PartnerLogo = styled.img`
  max-height: 56px;
  display: flex;
  align-items: center;
`;
